import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 0,
      name: i18n.t('tipos.metadato.simple')
    },
    {
      id: 1,
      name: i18n.t('tipos.metadato.self_feeding_list')
    },
    {
      id: 2,
      name: i18n.t('tipos.metadato.non_self_feeding_list')
    }
  ]
}

export function TIPOS_METADATOS_CREACION (state) {
  return configHelper.getConfig(state, 'TIPOS_METADATOS_CREACION', GenerateConfig)
}
